import React, { useEffect, useRef } from 'react';
import { Html, useGLTF } from '@react-three/drei';
import * as THREE from 'three';
import { useStore } from '@/store';
import gsap, { Sine } from 'gsap';
import { cm } from '@/data/scales';

const Person: React.FC = () => {
  const refModel = useRef<THREE.Group>();
  const refBox = useRef<THREE.BoxHelper>();
  const refGroup = useRef<THREE.Group>();
  const gltf = useGLTF('/lowpoly-person.glb');
  const { scene } = gltf;
  const artId = useStore((s) => s.artId);
  const getArtNow = useStore((s) => s.getArtNow);

  useEffect(() => {
    const box = refBox?.current;
    const model = refModel?.current;
    if (model) {
      model.traverse((c) => {
        if (c.type === 'Mesh') {
          const node = c as THREE.Mesh;
          node.material = new THREE.MeshStandardMaterial({ color: 'gray' });
        }
      });
    }
    if (box && model) {
      // calculating model size
      const box3 = new THREE.Box3();
      const size = new THREE.Vector3();
      box3.setFromObject(box);
      box3.getSize(size);
      const modelScale = 160 / size.y;
      model.scale.setScalar(modelScale);
      box.update();
    }
  }, [refBox?.current, refModel?.current]);
  useEffect(() => {
    const artNow = getArtNow();
    const artMesh = artNow?.mesh;
    const group = refGroup?.current;
    if (artMesh && group) {
      gsap.to(group.position, { x: artMesh.position.x, ease: Sine.easeInOut });
    }
  }, [artId]);
  return (
    <group position={[0, -100, -50]} ref={refGroup}>
      <Html position={[0, cm(160 + 10), 0]}>160cm</Html>
      <primitive
        object={scene}
        ref={refModel}
        rotation={[0, Math.PI * -0.5, 0]}
      />
      {refModel?.current && (
        <boxHelper
          args={[refModel.current, 0xffffff]}
          ref={refBox}
          visible={false}
        />
      )}
    </group>
  );
};

export default Person;
